<template>
  <div class="dash-root">
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#3ea56e"
      size="128"
      is-full-screen
    />

    <!-- Page Title -->
    <div class="dash-page-header">
      <div>
        <p class="dash-page-header__eyebrow">Welcome back, Admin</p>
        <h1 class="dash-page-header__title">Dashboard</h1>
      </div>
    </div>

    <!-- Stat Cards -->
    <v-row class="mb-2" v-if="stats != ''">

      <!-- Total Users -->
      <v-col cols="12" sm="6" lg="4">
        <router-link to="/customerList" style="text-decoration:none;">
          <div class="stat-card">
            <div class="stat-card__left">
              <div class="stat-card__icon-box" style="background:#e8f7ee;">
                <v-img src="./../../assets/iconsets/users.png" height="26px" contain></v-img>
              </div>
            </div>
            <div class="stat-card__right">
              <span class="stat-card__value">{{ stats.clientcount }}</span>
              <span class="stat-card__label">Total Users</span>
              <span class="stat-card__link">
                View all &nbsp;<v-icon size="12" color="#3ea56e">mdi-arrow-right</v-icon>
              </span>
            </div>
            <div class="stat-card__stripe" style="background: linear-gradient(180deg, #43e97b, #3ea56e);"></div>
          </div>
        </router-link>
      </v-col>

      <!-- Active Sellers -->
      <v-col cols="12" sm="6" lg="4">
        <router-link to="/SellerList" style="text-decoration:none;">
          <div class="stat-card">
            <div class="stat-card__left">
              <div class="stat-card__icon-box" style="background:#e8f0ff;">
                <v-img src="./../../assets/iconsets/sellers.png" height="26px" contain></v-img>
              </div>
            </div>
            <div class="stat-card__right">
              <span class="stat-card__value">{{ stats.sellercount }}</span>
              <span class="stat-card__label">Active Sellers</span>
              <span class="stat-card__link">
                View all &nbsp;<v-icon size="12" color="#5c7cfa">mdi-arrow-right</v-icon>
              </span>
            </div>
            <div class="stat-card__stripe" style="background: linear-gradient(180deg, #748ffc, #5c7cfa);"></div>
          </div>
        </router-link>
      </v-col>

      <!-- Pending Sellers -->
      <v-col cols="12" sm="6" lg="4">
        <router-link to="/pendingSeller" style="text-decoration:none;">
          <div class="stat-card">
            <div class="stat-card__left">
              <div class="stat-card__icon-box" style="background:#fff3e0;">
                <v-img src="./../../assets/iconsets/sellers.png" height="26px" contain></v-img>
              </div>
            </div>
            <div class="stat-card__right">
              <span class="stat-card__value">{{ stats.pendingsellercount }}</span>
              <span class="stat-card__label">Pending Sellers</span>
              <span class="stat-card__link">
                View all &nbsp;<v-icon size="12" color="#f76707">mdi-arrow-right</v-icon>
              </span>
            </div>
            <div class="stat-card__stripe" style="background: linear-gradient(180deg, #ffa94d, #f76707);"></div>
          </div>
        </router-link>
      </v-col>

    </v-row>

    <!-- Chart -->
    <v-row>
      <v-col cols="12">
        <div class="chart-card" v-if="flag">
          <div class="chart-card__header">
            <div>
              <h2 class="chart-card__title">Monthly Analytics</h2>
              <!-- <p class="chart-card__subtitle">Transactions · Clients · Products overview</p> -->
            </div>
            <div class="chart-legend">
              <span class="chart-legend__dot" style="background:#3ea56e;"></span><span>Transactions</span>
              <span class="chart-legend__dot" style="background:#5c7cfa;"></span><span>Clients</span>
              <span class="chart-legend__dot" style="background:#f76707;"></span><span>Products</span>
            </div>
          </div>
          <div class="chart-card__body">
            <apexchart
              type="bar"
              height="320"
              :options="chartOptions"
              :series="series"
            ></apexchart>
          </div>
        </div>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "BasicDashboard",
  data: () => ({
    appLoading: false,
    stats: "",
    flag: false,
    graph: [],
    user: [],
    type: "",
    fill: true,
    fill2: true,
    padding: 8,
    radius: 50,
    width: 1,
    radius2: 0,
    padding2: 0,
    width2: 4,
    value: [0, 2, 5, 9, 5, 10, 3, 5, 1, 8, 2, 9, 0],
    value2: [1, 2, 5, 9, 5, 10, 3, 5, 1, 8, 2, 9, 4],
    task: null,
    selected: [2],
    tasks: [
      { done: false, text: "Check emails of Mr.Shah" },
      { done: false, text: "Give salary to employee" },
    ],
    status: [
      { value: "Last Year", text: "Last Year" },
      { value: "Last 6 Months", text: "Last 6 Months" },
      { value: "Last 4 Months", text: "Last 4 Months" },
      { value: "Last 3 Months", text: "Last 3 Months" },
    ],
    series: [
      { name: "Transaction", data: [] },
      { name: "Client", data: [] },
      { name: "Product", data: [] },
    ],
    chartOptions: {
      chart: {
        type: "bar",
        height: 320,
        toolbar: { show: false },
        fontFamily: "poppinsmedium, Roboto, sans-serif",
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "50%",
          borderRadius: 5,
          endingShape: "rounded",
        },
      },
      colors: ["#3ea56e", "#5c7cfa", "#f76707"],
      dataLabels: { enabled: false },
      stroke: { show: true, width: 2, colors: ["transparent"] },
      grid: {
        borderColor: "#cbd5e1",
        strokeDashArray: 5,
      },
      xaxis: {
        categories: [],
        axisBorder: { show: false },
        axisTicks: { show: false },
        labels: { style: { colors: "#9aa0ac", fontSize: "11px" } },
      },
      yaxis: {
        labels: { style: { colors: "#9aa0ac", fontSize: "11px" } },
      },
      fill: { opacity: 1 },
      legend: { show: false },
      tooltip: {
        y: {
          formatter: function (val) { return +val; },
        },
      },
    },
  }),
  mounted() {
    this.loadStats();
  },
  methods: {
    loadStats() {
      this.appLoading = true;
      axios({
        url: "dashboard/admin",
        method: "GET",
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
        .then((response) => {
          this.appLoading = false;
          this.stats = response.data;
          this.type = response.data.type;
          this.graph = response.data.graph;
          for (var i = 0; i < this.graph.length; i++) {
            this.chartOptions.xaxis.categories.push(
              this.graph[i].month + this.graph[i].year
            );
            this.series[0].data.push(this.graph[i].transaction);
            this.series[1].data.push(this.graph[i].clientcount);
            this.series[2].data.push(this.graph[i].productcount);
          }
          this.flag = true;
        })
        .catch((e) => {
          this.appLoading = false;
          console.log(e);
        });
    },
  },
};
</script>

<style scoped>
/* ─── Root ─────────────────────────────────────────── */
.dash-root {
  font-family: poppinsmedium, Roboto, sans-serif;
}

/* ─── Page Header ──────────────────────────────────── */
.dash-page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 24px;
}

.dash-page-header__eyebrow {
  font-size: 13px;
  color: #8a93a4;
  margin: 0 0 4px;
  font-family: poppinsmedium, sans-serif;
}

.dash-page-header__title {
  font-size: 22px;
  font-weight: 700;
  color: #1a202c;
  margin: 0;
  font-family: poppinsbold, sans-serif;
  line-height: 1.2;
}

.dash-page-header__badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #e8f7ee;
  border: 1px solid #c6ecd8;
  border-radius: 50px;
  padding: 5px 12px;
  font-size: 12px;
  font-weight: 600;
  color: #2e9e60;
  margin-top: 4px;
}

/* ─── Stat Card ────────────────────────────────────── */
.stat-card {
  position: relative;
  background: #ffffff;
  border: 1px solid #eaedf0;
  border-radius: 14px;
  padding: 20px 20px 20px 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
}

.stat-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
}

/* coloured left stripe */
.stat-card__stripe {
  position: absolute;
  left: 0;
  top: 0;
  width: 5px;
  height: 100%;
  border-radius: 14px 0 0 14px;
}

.stat-card__left {
  flex-shrink: 0;
}

.stat-card__icon-box {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}

.stat-card__right {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.stat-card__value {
  font-size: 30px;
  font-weight: 800;
  line-height: 1;
  color: #1a202c;
  font-family: poppinsbold, sans-serif;
}

.stat-card__label {
  font-size: 12px;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: #8a93a4;
  font-family: poppinssemibold, sans-serif;
  margin-top: 4px;
}

.stat-card__link {
  font-size: 12px;
  color: #3ea56e;
  font-family: poppinssemibold, sans-serif;
  margin-top: 6px;
  display: inline-flex;
  align-items: center;
}

/* ─── Chart Card ───────────────────────────────────── */
.chart-card {
  background: #ffffff;
  border: 1px solid #eaedf0;
  border-radius: 16px;
  overflow: hidden;
}

.chart-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 0;
  flex-wrap: wrap;
  gap: 12px;
}

.chart-card__title {
  font-size: 16px;
  font-weight: 700;
  color: #1a202c;
  margin: 0;
  font-family: poppinsbold, sans-serif;
}

.chart-card__subtitle {
  font-size: 12px;
  color: #8a93a4;
  margin: 3px 0 0;
}

.chart-legend {
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: 12px;
  color: #5a6478;
  font-family: poppinsmedium, sans-serif;
}

.chart-legend__dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 4px;
}

.chart-card__body {
  padding: 8px 16px 16px;
}
</style>
